import { Link, useParams } from "react-router-dom";
import MobileForm from "../../../../../../components/MobileForm";
import { makeStyles } from '@material-ui/core';
import { Box }  from '@material-ui/core';
import { useEffect, useState } from "react";
import useAPI from 'hooks/useAPI';
import useCustomer from 'hooks/useCustomer';

const useStyles = makeStyles({
  formButton: {
    width: '30px',
    background: '#6271CB',
    color: 'white',
    borderRadius: 5,
    display: 'block',
    textDecoration: 'none',
    textAlign: 'center',
    paddingTop: 10,
    paddingBottom: 10,
    marginBottom: 7,
    marginLeft: 20,
    marginRight: 20,
  }
});

export default function RepairedAndReplacedPage1() {
  const styles = useStyles()
  const { version, appointmentId, enrollmentNumber } = useParams();
  const useValidation = require(`./v${version}/useValidation`).default;
  const background = require(`./v${version}/background.png`);
  const fields = require(`./v${version}/fields.json`);
  const { width: bgWidth, height: bgHeight } = require(`./v${version}/dimensions.json`);
  const [submissions, setSubmissions] = useState([]);
  const { customer } = useCustomer(enrollmentNumber);
  const api = useAPI();

  const getForms = () => {
    return api 
      .get(`/appointments/${appointmentId}/submissions`)
      .then(res => setSubmissions(res.data.submissions))
      .catch(err => console.log(err))
  };
  
  const width = document.documentElement.clientWidth;
  const ratio = width / bgWidth;
  const newHeight = bgHeight * ratio;

  const [volume1Values, setVolume1Values] = useState({
    length: 0,
    width: 0,
    height: 0
  });

  const [volume2Values, setVolume2Values] = useState({
    length: 0,
    width: 0,
    height: 0
  });

  const [area1Values, setArea1Values] = useState({
    width: 0,
    height: 0,
    reductionFactor: 0,
    quantity: 0
  });

  const [area2Values, setArea2Values] = useState({
    width: 0,
    height: 0,
    reductionFactor: 0,
    quantity: 0
  });

  const [volume1, setVolume1] = useState(0);
  const [volume2, setVolume2] = useState(0);
  const [area1, setArea1] = useState(0);
  const [area2, setArea2] = useState(0);

  // const cacheMathValues = async (volume1, volume2, area1, area2) => {
  //   return db.forms
  //     .where({
  //       appointmentId,
  //       type: 'repairedAndReplacedPage1',
  //       version
  //     })
  //     .modify({
  //       'area1Total': volume1,
  //       'area2Total': volume2,
  //       'vent1_total': area1,
  //       'vent2_total': area2,
  //     })
  //     .catch(err => console.log(err))
  // }
  
  // const handleMath = async () => {
  //   try {
  //     const record = await db.forms
  //       .where({ appointmentId, type: 'repairedAndReplacedPage1', version })
  //       .first();

  //     if (record) {
  //       const {
  //         area1L, area1W, area1H,
  //         area2L, area2W, area2H,
  //         vent1_w, vent1_h, vent1_reductionFactor, vent1_quantity,
  //         vent2_w, vent2_h, vent2_reductionFactor, vent2_quantity
  //       } = record; 

  //       setVolume1Values({
  //         length: area1L,
  //         width: area1W,
  //         height: area1H
  //       })

  //       setVolume2Values({
  //         length: area2L,
  //         width: area2W,
  //         height: area2H
  //       })

  //       setArea1Values({
  //         width: vent1_w,
  //         height: vent1_h,
  //         reductionFactor: vent1_reductionFactor,
  //         quantity: vent1_quantity
  //       })

  //       setArea2Values({
  //         width: vent2_w,
  //         height: vent2_h,
  //         reductionFactor: vent2_reductionFactor,
  //         quantity: vent2_quantity
  //       })

  //       const volume1LengthValue = parseFloat(area1L) || 0;
  //       const volume1WidthValue = parseFloat(area1W) || 0;
  //       const volume1HeightValue = parseFloat(area1H) || 0;

  //       const volume2LengthValue = parseFloat(area2L) || 0;
  //       const volume2WidthValue = parseFloat(area2W) || 0;
  //       const volume2HeightValue = parseFloat(area2H) || 0;

  //       const area1WidthValue = parseFloat(vent1_w) || 0;
  //       const area1HeightValue = parseFloat(vent1_h) || 0;
  //       const area1ReductionFactorValue = parseFloat(vent1_reductionFactor) || 0;
  //       const area1QuantityValue = parseFloat(vent1_quantity) || 0;

  //       const area2WidthValue = parseFloat(vent2_w) || 0;
  //       const area2HeightValue = parseFloat(vent2_h) || 0;
  //       const area2ReductionFactorValue = parseFloat(vent2_reductionFactor) || 0;
  //       const area2QuantityValue = parseFloat(vent2_quantity) || 0;

  //       const volume1Total = volume1LengthValue * volume1HeightValue * volume1WidthValue;
  //       const volume2Total = volume2LengthValue * volume2HeightValue * volume2WidthValue;
  //       const area1Total = area1WidthValue * area1HeightValue * area1ReductionFactorValue * area1QuantityValue;
  //       const area2Total = area2WidthValue * area2HeightValue * area2ReductionFactorValue * area2QuantityValue;

  //       await cacheMathValues(volume1Total, volume2Total, area1Total, area2Total);
        
  //       setVolume1(volume1Total);
  //       setVolume2(volume2Total);
  //       setArea1(area1Total);
  //       setArea2(area2Total);

  //       console.log(`calculated total volume1 ${volume1Total}`)
  //     }
  //   }
  //   catch (err) {
  //     console.log(err);
  //   }
  // };

  // const handleFieldChange = (fieldName, value) => {
  //   handleMath((prevValues) => ({
  //     ...prevValues,
  //     [fieldName]: value,
  //   }));
  // };

  // useEffect(() => {
  //   handleMath();
  // }, [volume1])

  useEffect(() => {
    if(customer) {
      getForms();
    }
  }, [customer]);

  const targetIds = ["677848fa45b2d61140c550ad"]

  const matchingSubmissionIds = submissions
    .filter(submission => targetIds.includes(submission.form._id))
    .map(submission => {
      // Extract the numeric page number from the form abbreviation (e.g., repairedAndReplacedPage3 -> 3)
      const match = submission.form.abbr.match(/Page(\d+)/i);
      const pageNumber = match ? parseInt(match[1], 10) : Infinity; // default to Infinity if no match
      return { ...submission, pageNumber };
  })
  .sort((a, b) => a.pageNumber - b.pageNumber); // Sort by page number

  return (
    <div>
      <MobileForm
        type="repairedAndReplacedPage1"
        version={version}
        width={width}
        height={newHeight}
        useValidation={useValidation}
        background={background}
        fields={fields}
      />
      <Box display="flex" flexDirection="row">
        {matchingSubmissionIds.map(submission => (
          <Link
            key={submission._id}
            to={`/customers/${enrollmentNumber}/appointment/${appointmentId}/form/${submission.form.abbr}/${version}/${submission._id}`}
            className={styles.formButton}
          >
            {submission.pageNumber}
          </Link>
        ))}
      </Box>
    </div>
  );
};